function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import IconEmoticonDeadOutline from '~icons/mdi/emoticon-dead-outline';
import { theme, typography } from '@arc/frontend/ui-theme';
const styles = {
  container: process.env.NODE_ENV === "production" ? {
    name: "wco9ji",
    styles: "display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;height:100%"
  } : {
    name: "1fgojex-container",
    styles: "display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;height:100%;label:container;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  icon: /*#__PURE__*/css({
    width: '100%',
    height: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '4rem',
    maxHeight: '4rem',
    color: theme.colors.text.hint
  }, process.env.NODE_ENV === "production" ? "" : ";label:icon;"),
  message: /*#__PURE__*/css(typography.emptyLarge, "text-align:center;max-width:20rem;" + (process.env.NODE_ENV === "production" ? "" : ";label:message;"))
};
/** Indicate that an error has occurred by displaying an icon in the center of the container. */
export function ErrorIndicator({
  message
}) {
  return <div css={styles.container}>
			<IconEmoticonDeadOutline css={styles.icon} />
			{message ? <div css={styles.message}>{message}</div> : null}
		</div>;
}